import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/grade_FILL0_wght500_GRAD-25_opsz48.svg'
import _imports_1 from '../assets/stack_FILL0_wght500_GRAD-25_opsz48.svg'
import _imports_2 from '../assets/stat_3_FILL0_wght500_GRAD-25_opsz48.svg'
import _imports_3 from '../assets/transcribe_FILL0_wght500_GRAD-25_opsz48.svg'


const _hoisted_1 = { class: "bottom-nav" }
const _hoisted_2 = { class: "nav-label" }
const _hoisted_3 = { class: "nav-label" }
const _hoisted_4 = { class: "nav-label" }
const _hoisted_5 = { class: "nav-label" }
const _hoisted_6 = { class: "nav-label" }
const _hoisted_7 = { class: "nav-label" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "nav-icon" }
const _hoisted_10 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_12 = { class: "nav-label" }
const _hoisted_13 = { class: "nav-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "nav-item",
      "exact-active-class": "nav-item--active"
    }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "nav-icon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.jsonData.navGames), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/about",
      class: "nav-item",
      "active-class": "nav-item--active"
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "nav-icon" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          })
        ], -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.navAbout), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/news",
      class: "nav-item",
      "active-class": "nav-item--active"
    }, {
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "nav-icon" }, [
          _createElementVNode("img", {
            src: _imports_2,
            alt: ""
          })
        ], -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.jsonData.navNews), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/contacts",
      class: "nav-item",
      "active-class": "nav-item--active"
    }, {
      default: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "nav-icon" }, [
          _createElementVNode("img", {
            src: _imports_3,
            alt: ""
          })
        ], -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.jsonData.navContacts), 1)
      ]),
      _: 1
    }),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/account",
          class: "nav-item",
          "active-class": "nav-item--active"
        }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "nav-icon nav-icon--user" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "8",
                  r: "4",
                  stroke: "currentColor",
                  "stroke-width": "1.8"
                }),
                _createElementVNode("path", {
                  d: "M4 20c0-3.9 3.6-7 8-7s8 3.1 8 7",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round"
                })
              ])
            ], -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.jsonData.navAccount), 1)
          ]),
          _: 1
        }))
      : (_ctx.showRegisterButton)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: "#",
            class: "nav-item",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAuth && _ctx.openAuth(...args)), ["prevent"]))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "nav-icon nav-icon--user" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "8",
                  r: "4",
                  stroke: "currentColor",
                  "stroke-width": "1.8"
                }),
                _createElementVNode("path", {
                  d: "M4 20c0-3.9 3.6-7 8-7s8 3.1 8 7",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round"
                })
              ])
            ], -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.jsonData.navSignIn), 1)
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "nav-item nav-item--theme",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
      "aria-label": _ctx.jsonData.navTheme
    }, [
      _createElementVNode("span", _hoisted_9, [
        (_ctx.isLight)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[9] || (_cache[9] = [
              _createElementVNode("path", {
                d: "M20.5 14.2A8.5 8.5 0 1 1 9.8 3.5a7 7 0 0 0 10.7 10.7z",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linejoin": "round"
              }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[10] || (_cache[10] = [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "4.2",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, null, -1),
              _createElementVNode("path", {
                d: "M12 2.5v2.2M12 19.3v2.2M4.2 12H2M22 12h-2.2M5.6 5.6l1.5 1.5M16.9 16.9l1.5 1.5M18.4 5.6l-1.5 1.5M7.1 16.9l-1.5 1.5",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linecap": "round"
              }, null, -1)
            ])))
      ]),
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.jsonData.navTheme), 1)
    ], 8, _hoisted_8),
    (_ctx.showLangSwitcher)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "nav-item nav-item--lang",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleLocale && _ctx.toggleLocale(...args))),
          "aria-label": "Language"
        }, [
          _cache[11] || (_cache[11] = _createStaticVNode("<span class=\"nav-icon\"><svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"9\" stroke=\"currentColor\" stroke-width=\"1.8\"></circle><ellipse cx=\"12\" cy=\"12\" rx=\"4\" ry=\"9\" stroke=\"currentColor\" stroke-width=\"1.8\"></ellipse><path d=\"M3.3 9h17.4M3.3 15h17.4\" stroke=\"currentColor\" stroke-width=\"1.8\"></path></svg></span>", 1)),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.isRu ? 'EN' : 'RU'), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}